// src/pages/AboutUsPage.js
import React from 'react';
// Assuming you have a Header and Footer component defined elsewhere
// import Header from '../components/Header'; 
// import Footer from '../components/Footer'; 
import OurStorySection from '../components/AboutUsContent';
import PageTransition from '../components/PageTransition';

function AboutUsPage() {
  return (
    <div className="about-us-page min-h-screen flex flex-col">
      {/* <Header /> */} 
      
      <main className="flex-grow">
        <OurStorySection />
      </main>
      
      {/* <Footer /> */}
    </div>
  );
}

export default PageTransition(AboutUsPage);
